export default __webpack_public_path__ + "static/media/no-conversations.65da1df5.svg";